// Live "test this unsaved draft against a real account" panel, ported from bliss-audit's
// admin/TestPanel.tsx. Descoped for this port: there is no rule evaluator or agent-execution
// engine in bpm-lambdas (that logic now lives in the Bedrock audit agent — see the port plan
// for DEV-23143's Phase 6), so this only explains what's missing rather than faking a result.
// Once Phase 6's agent-run plumbing lands, this becomes a real POST /admin/preview call for
// agent-type skills; rule-type live-testing remains an explicit follow-up decision.
export const TestPanel = () => (
  <div className='google-ads-audit-admin-test-panel'>
    <div className='google-ads-audit-form-section-title'>Test against a real account</div>
    <p className='google-ads-audit-subtitle'>
      Live testing runs a draft skill against real Google Ads accounts before saving. This depends
      on the audit agent integration, which isn&apos;t wired up yet — check back once that lands.
    </p>
  </div>
);
